module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"runningTime":"Operating hours"},"de":{"runningTime":"Betriebsstunden"},"fr":{"runningTime":"Heures de fonctionnement"},"it":{"runningTime":"Ore di funzionamento"}}')
  delete Component.options._Ctor
}
